import React from 'react';
import Table from 'components/Table';
import dayjs from 'dayjs';
import { t } from 'i18next';
import EditButton from 'components/ActionButtons/editButton';
import DeleteButton from 'components/ActionButtons/deleteButton';
function List({ headers, data, onEdit, buttons, onDelete }) {
  return (
    <Table
      headers={headers.map((e) => (
        <th scope='col' key={`thead-${Math.random()}`}>
          {t(e)}
        </th>
      ))}
      title={t('sidebar.location')}
      subtitle={t('district')}
      buttons={buttons}
      data={data}
      rows={data.map((e, index) => (
        <tr key={`table-row-${Math.random()}`}>
          <td>{index + 1}</td>
          <td>{e.name}</td>
          <td>{e.region.name}</td>

          <td>{dayjs(e.createdAt).format('DD/MM/YYYY HH:mm')}</td>
          <td>{e.modifiedBy?.name}</td>
          <td>
            <EditButton onClick={() => onEdit(e)} />
            <DeleteButton onClick={() => onDelete(e)} />
          </td>
        </tr>
      ))}
    />
  );
}

export default List;
